export const subscriptionEndpoints = {
  // Creates the platform-authoritative Account + pending Subscription (#219).
  SIGNUP: '/subscriptions/signup/',
}
